
import { PatientManagementDashboard } from "@/components/patient-management/PatientManagementDashboard";

const PatientManagement = () => {
  return <PatientManagementDashboard />;
};

export default PatientManagement;
